import React, { useState,useEffect} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faPlus, faSave,faArrowLeft, faArrowRight,faBroom, faCaretRight, faCaretLeft } from '@fortawesome/free-solid-svg-icons';
import './StockLoad.css'


import { Tooltip } from 'react-tooltip';
////////////////////////////////////////

const LoadLines = () => {
    // Option Panel visibility
    const [panel1Visible, setPanel1Visible] = useState(true);
    // Advanced Panel visibility
    // const [panel2Visible, setPanel2Visible] = useState(true);

    // Date Picker

    const [selectedDate, setSelectedDate] = useState(null);

    const handleChange = (date) => setSelectedDate(date);
       //        API CODE
       const [apiData, setApiData] = useState([]);
       const [apiData1, setApiData1] = useState([]);
       const [apiData2, setApiData2] = useState([]);
       const [apiData3, setApiData3] = useState([]);
       const [currentPage, setCurrentPage] = useState(1);
       const [itemsPerPage, setItemsPerPage] = useState(5); // Adjust this number as needed
  
       const fetchData = async () => {
          const username = 'manager'; // Replace with your username
          const password = 'manager'; // Replace with your password
          const apiUrl = 'https://77.92.189.102/iitprecastvertical/api/v1/BaqSvc/IIT_GetAllParts6_kinetic(PRECAST)'; // Adjust the URL as needed
  
          try {
              const response = await fetch(apiUrl, {
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': 'Basic ' + btoa(username + ":" + password)
                  }
              });
  
              if (!response.ok) {
                  throw new Error('Network response was not ok');
              }
              const data = await response.json();
              // Check if data is an object and contains the 'value' property which is an array
              if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                  setApiData(data.value);
              } else {
                  console.error('API response does not contain the expected array in the "value" property:', data);
              }
          } catch (error) {
              console.error('There was a problem with your fetch operation:', error);
          }
      };

      const fetchData2 = async () => {
        const username = 'manager'; // Replace with your username
        const password = 'manager'; // Replace with your password
        const apiUrl1 = 'https://77.92.189.102/IITPrecastVertical/api/v1/BaqSvc/IIT_GetAllPartsLines_Kinetic(PRECAST)'; // Adjust the URL as needed

        try {
            const response = await fetch(apiUrl1, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            // Check if data is an object and contains the 'value' property which is an array
            if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                setApiData1(data.value);
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }
        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        }
    };

    const fetchData3 = async () => {
        const username = 'manager'; // Replace with your username
        const password = 'manager'; // Replace with your password
        const apiUrl3 = 'https://77.92.189.102/iitprecastvertical/api/v1/BaqSvc/IIT_GetAllConsParts_Kinetic(PRECAST)'; // Adjust the URL as needed

        try {
            const response = await fetch(apiUrl3, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            // Check if data is an object and contains the 'value' property which is an array
            if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                setApiData2(data.value);
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }
        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        }
    };
    const fetchData4 = async () => {
        const username = 'manager'; // Replace with your username
        const password = 'manager'; // Replace with your password
        const apiUrl4 = 'https://77.92.189.102/iitprecastvertical/api/v1/BaqSvc/IIT_GetAllPartsConsLinesTest(PRECAST)'; // Adjust the URL as needed

        try {
            const response = await fetch(apiUrl4, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            // Check if data is an object and contains the 'value' property which is an array
            if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                setApiData3(data.value);
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }
        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        }
    };
      useEffect(() => {
          fetchData();
          fetchData2();
          fetchData3();
          fetchData4();
      }, []); // Fetch data on component mount
  
      const renderTableRows = () => {
          const startIndex = (currentPage - 1) * itemsPerPage;
          const endIndex = startIndex + itemsPerPage;
          const currentItems = apiData.slice(startIndex, endIndex);
  
          return currentItems.map((item, index) => (
              <tr key={index}>
                <td>
                    <input
                        type="checkbox"
                    />
                </td>
                  <td>
                    <input
                        type="checkbox"
                        checked={item.Calculated_select ? 'true' : ''}
                    />
                </td>
                  <td>{item.PartLot_ErectionSequence_c}</td>
                  <td>{item.Part_PartNum}</td>
                  <td>{item.PartLot_LotNum}</td>
                  <td>{item.PartLot_PartLotDescription}</td>
                  <td>{item.PartLot_TypicalID_c}</td>
                  <td>{item.PartLot_BuildingType_c}</td>
                  <td>{item.PartLot_Ton_c}</td>
                  <td>{item.PartWhse_WarehouseCode}</td>
                  <td>{item.Part_IUM}</td>
                  <td>{item.PartBin_BinNum}</td>
                  <td>{item.PartLot_ElementStatus_c}</td>
                  <td>{item.ProdGrup_Description}</td>
                  <td>{item.PartLot_M3_c}</td>
              </tr>
          ));
      };
      const renderTableRows1 = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = apiData1.slice(startIndex, endIndex);

        return currentItems.map((item, index) => (
            <tr key={index}>
                <td>{item.Calculated_Select}</td>
                <td>{item.UD103A_Number06}</td>
                <td>{item.UD103A_Character01}</td>
                <td>{item.UD103A_Character02}</td>
                <td>{item.UD103A_Number05}</td>
                <td>{item.UD103A_Number04}</td>
                <td>{item.UD103A_Number03}</td>
                <td>{item.UD103A_Key1}</td>
                <td>{item.UD103A_Character03}</td>
            </tr>
        ));
    };
    const renderTableRows2 = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = apiData2.slice(startIndex, endIndex);

        return currentItems.map((item, index) => (
            <tr key={index}>
                <td>
                    <input
                        type="checkbox"
                        checked={item.Calculated_select? 'true' : ''}
                    />
                </td>
                <td>{item.Part_PartNum}</td>
                <td>{item.Part_IUM}</td>
                <td>{item.Calculated_OnHandQty}</td>
                <td>{item.Calculated_Quantity}</td>
                <td>{item.PartBin_BinNum}</td>
            </tr>

        ));
    };
    const renderTableRows3 = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = apiData3.slice(startIndex, endIndex);

        return currentItems.map((item, index) => (
            <tr key={index}>
                <td>
                    <input
                        type="checkbox"
                    />
                </td>
                <td>{item.UD103A_Character01}</td>
                <td>{item.UD103A_ShortChar07}</td>
                <td>{item.Calculated_Qty}</td>
                <td>
                    <input
                        type="checkbox"
                        checked={item.Calculated_Select? 'true' : ''}
                    />
                </td>
            </tr>
        ));
    };
      const goToNextPage = () => {
          const totalPages = Math.ceil(apiData.length / itemsPerPage);
          if (currentPage < totalPages) {
              setCurrentPage(currentPage + 1);
          }
      };
  
      const goToPreviousPage = () => {
          if (currentPage > 1) {
              setCurrentPage(currentPage - 1);
          }
      };
  
  
    // Toggle Option Panel visibility
    const togglePanel1Visibility = () => {
        setPanel1Visible(!panel1Visible);
    }


    return (
        <div className='card panelcard'>
            <div className='DetailsForm'>
                <div className="card-header">
                    <h2 className='panel-title-report'>Stock Load - Lines</h2>
                    <div className='ctrl-btns-report'>
                        <button className="btn" id='Add'>
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                        <Tooltip
                            anchorSelect="#Add"
                            content="Add"
                            place='bottom'
                        />
                        <button className="btn" id='Save'>
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <Tooltip
                            anchorSelect="#Save"
                            content="Save"
                            place='bottom'
                        />
                         <button className="btn" id='Clear'>
                            {/* <FontAwesomeIcon icon={faBroom} /> */}
                            <svg className='myBroom' width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="white" stroke-width="0.744">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path d="M22.4524 1.92267C22.7452 2.21557 22.7452 2.69044 22.4524 2.98333L16.1393 9.29634C15.9927 9.11579 15.8353 8.94105 15.6673 8.77297C15.4768 8.58252 15.2778 8.40582 15.0715 8.24289L21.3917 1.92267C21.6846 1.62978 22.1595 1.62978 22.4524 1.92267Z" fill="#000"></path>
                                    <path d="M15.0277 9.34728C12.7822 7.10177 9.14153 7.10177 6.89601 9.34728L6.65198 9.59131L14.7837 17.723L15.0277 17.479C17.2733 15.2335 17.2733 11.5928 15.0277 9.34728Z" fill="#000"></path>
                                    <path d="M1.8838 12.9659L5.49664 10.5573L13.8177 18.8784L11.4091 22.4912C11.2845 22.6782 11.0826 22.7994 10.859 22.8215C10.6354 22.8437 10.4137 22.7644 10.2548 22.6055L1.76949 14.1202C1.61061 13.9613 1.53133 13.7396 1.55347 13.516C1.57561 13.2924 1.69684 13.0905 1.8838 12.9659Z" fill="#000"></path>
                                </g>
                            </svg>
                        </button>
                        <Tooltip
                            anchorSelect="#Clear"
                            content="Clear Form"
                            place='bottom'
                        />
                    </div>
                </div>
                {/* Panel 1  */}
                <div className="card-body">
                    <div className="card-header">
                        <button type="button" className="toggle-table-icon" onClick={togglePanel1Visibility}>
                            <FontAwesomeIcon icon={panel1Visible ? faArrowDown : faArrowUp} />
                        </button>
                        <h5 className='card-body-title'>
                            Lines
                        </h5>
                    </div>
                    {panel1Visible && (
                        <div class="table-responsive-md">
                            <div className='TruckForm'>
                                <form>
                                    <div class="row row1">
                                        <div className="col-3 leftCol-lines">
                                            <div className='grid-inputs'>
                                                <div class="label-input-box-ingrid">
                                                    <label>Typical ID:</label>
                                                    <input type="text" autocomplete="off" id="endDate" name="daterange" class="Elementidinput-report" />
                                                </div>
                                                <div class="label-input-box-ingrid">
                                                    <label>Element ID:</label>
                                                    <input type="text" autocomplete="off" id="endDate" name="daterange" class="Elementidinput-report" />
                                                </div>
                                                <div class="label-input-box-ingrid">
                                                    <button type='button' className='Loadbutton'>Refresh</button>
                                                </div>
                                            </div>
                                            <div className='grid-inputs'>
                                                <div className='DetailsForm loadgrid-left'>
                                                <div className="scrollable-table-body">
                                                    <div class="table-responsive">
                                                        <table className="table table-bordered-small">
                                                            {/* Table content */}
                                                            <thead className='table-primary'>
                                                                <tr className='bg-primary text-white'>
                                                                    <th>Selected</th>
                                                                    <th>Select</th>
                                                                    <th>Erq Sequence</th>
                                                                    <th>Part Number</th>
                                                                    <th>Element ID</th>
                                                                    <th>Element Description</th>
                                                                    <th>TypicalID</th>
                                                                    <th>ID1</th>
                                                                    <th>Whse</th>
                                                                    <th>UOM</th>
                                                                    <th>Bin</th>
                                                                    <th>Element Status</th>
                                                                    <th>Product Group</th>
                                                                    <th>PartLot_M3_c</th>
                                                                    <th>Weight</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                
                                                                 {renderTableRows()}
                                                                
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="pagination">
                            <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                            <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                                <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                        </div>

                                                </div>

                                            </div>
                                            </div>
                                        </div>
                                        <div className='col-3 midCol-lines'>
                                            <div className='navigator-container mt-5 d-flex flex-column align-items-center'>
                                                <button type='button' className='Navbutton my-3'><FontAwesomeIcon icon={faCaretRight} className='rightleft-icon' /></button>
                                                <button type='button' className='Navbutton'><FontAwesomeIcon icon={faCaretLeft} className='rightleft-icon' /></button>
                                            </div>
                                        </div>
                                        <div className="col-3 rightCol-lines">
                                            <div className='grid-inputs'>
                                                <div class="label-input-box-ingrid">
                                                    <label>Plate No:</label>
                                                    <input type="text" autocomplete="off" id="endDate" name="daterange" class="Elementidinput-report" />
                                                </div>
                                                <div class="label-input-box-ingrid">
                                                    <label>Total Tons:</label>
                                                    <input type="text" autocomplete="off" id="endDate" name="daterange" class="Elementidinput-report" />
                                                </div>
                                                <div class="label-input-box-ingrid">
                                                    <label>Truck Capacity:</label>
                                                    <input type="text" autocomplete="off" id="endDate" name="daterange" class="Elementidinput-report" />
                                                </div>
                                            </div>
                                            <div className='DetailsForm loadgrid-right'>
                                                <div class="table-responsive">
                                                <div className="scrollable-table-body">
                                                    <table className="table table-bordered-small">
                                                        {/* Table content */}
                                                        <thead className='table-primary'>
                                                            <tr className='bg-primary text-white'>
                                                                <th>Select</th>
                                                                <th>Erq Sequence</th>
                                                                <th>Part Number</th>
                                                                <th>Volume</th>
                                                                <th>Area</th>
                                                                <th>Weight</th>
                                                                <th>Quantity</th>
                                                                <th>Element Status</th>
                                                                <th>UOM</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            
                                                             {renderTableRows1()}
                                                            
                                                        </tbody>
                                                    </table>
                                                </div>
                                                </div>
                                                <div className="pagination">
                            <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                            <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                                <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                        </div>
                                           
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row row2">
                                        <div class="col-3 leftCol-lines">
                                            <div className='grid-inputs'>
                                                <div class="label-input-box-ingrid">
                                                    <label>Part Num:</label>
                                                    <input type="text" autocomplete="off" id="endDate" name="daterange" class="Elementidinput-report" />
                                                </div>
                                                <div class="label-input-box-ingrid">
                                                    <label>Part Class:</label>
                                                    <input type="text" autocomplete="off" id="endDate" name="daterange" class="Elementidinput-report" />
                                                </div>
                                                <div class="label-input-box-ingrid">
                                                    <button type='button' className='Loadbutton'>Refresh</button>
                                                </div>
                                            </div>
                                            <div className='grid-inputs'>
                                                <div className='DetailsForm loadgrid-left'>
                                                <div className="scrollable-table-body">
                                                    <div class="table-responsive">
                                                        <table className="table table-bordered-small">
                                                            {/* Table content */}
                                                            <thead className='table-primary'>
                                                                <tr className='bg-primary text-white'>
                                                                    <th>Select</th>
                                                                    <th>PartNum</th>
                                                                    <th>UOM</th>
                                                                    <th>On HandQty</th>
                                                                    <th>Loading Qty</th>
                                                                    <th>Bin</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {renderTableRows2()}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    </div>
                                                    <div className="pagination">
                            <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                            <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                                <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                        </div>

                                                </div>

                                            </div>
                                        </div>
                                        <div className='col-3 midCol-lines'>
                                            <div className='navigator-container mt-5 d-flex flex-column align-items-center'>
                                                <button type='button' className='Navbutton my-3'><FontAwesomeIcon icon={faCaretRight} className='rightleft-icon' /></button>
                                                <button type='button' className='Navbutton'><FontAwesomeIcon icon={faCaretLeft} className='rightleft-icon' /></button>
                                            </div>
                                        </div>
                                        <div class="col-3 rightCol-lines">
                                            <div className='grid-inputs'>
                                                <div className='DetailsForm loadgrid-right tableleft'>
                                                    <div class="table-responsive">
                                                        <table className="table table-bordered-small">
                                                            {/* Table content */}
                                                            <thead className='table-primary'>
                                                                <tr className='bg-primary text-white'>
                                                                    <th>Select</th>
                                                                    <th>PartNum</th>
                                                                    <th>UOM</th>
                                                                    <th>Quantity</th>
                                                                    <th>Selected</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {renderTableRows3()}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    
                                                     <div className="pagination">
                                                    <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                                                        <FontAwesomeIcon icon={faArrowLeft} />
                                                    </button>
                                                    <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                    </button>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>

    );
};

export default LoadLines;